import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Snackbar from '../../../components/Snackbar';
import CardProfile from '../../../components/Profile/Card/';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import TrophieModal from '../../../components/Modal/TrophieModal';
import CourseAdded from '../../../components/Profile/Courses/CourseAdded';
import AddCourses from './AddCourses';
import { openModalFree } from "../../../store/actions/ModalFree";

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;
var ElementScroll = Scroll.Element;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
  },
  text: {
    color: '#484848',
    lineHeight: 'normal',
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {
    color: '#013957',
    cursor: 'pointer',
    margin: 0,
  },
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
  },
  divider: {
    border: '0.4px solid #e7e7e7',
    margin: '0 0 10px 0',
    width: '100%',
  },
}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    display: 'grid',
    '&::before': {
      height: 0,
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',
    backgroundColor: 'white',
  },
  content: {
    margin: 0,
    width: '100%',
    flexFlow: 'column',
    alignItems: 'flex-start',
    cursor: 'auto',
    //marginBottom: 8,
    //padding: 0,
    '&$expanded': {
      marginBottom: 16,
    },
  },
  expandIcon: {
    color: '#013957',
  },

  expanded: {
    //margin:0
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: '16px 0 0',
    display: 'block',
    borderRadius: 4,
  },
})(MuiExpansionPanelDetails);

const Courses = (props) => {
  const { authClient, coursesLawyer, trophie, openModalFree, membershipType } = props

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [alreadyRewarded, setAlreadyRewarded] = useState(trophie? trophie : false);
  const [openTrophieModal, setOpenTrophieModal] = useState(false);
  const [trophieValidation, setTrophieValidation] = useState(false);

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
    //setFlagEdit(false);
  };

  const handleTrophieModalOpen = (trophie) => {
    setTrophieValidation(trophie);
    finishOpeningTrophieModal();
  };

  const finishOpeningTrophieModal = () => {
    if (alreadyRewarded === false) {
      setOpenTrophieModal(true);
      setAlreadyRewarded(true);
    }
  };

  const switchAlreadyRewarded = (bool) => {
    setAlreadyRewarded(bool);
  };

  const [nElem, setnElem] = useState(0);
  const [helper, setHelper] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const [totalElements, setTotalElements] = useState(0);

  const helperTrue = () => {
    if (isFull && !isLimit && !checkLimit()) {
      //console.log('helperTrue');
      setHelper(true);
      setTotalElements((prev) => {
        if (prev) {
          return prev + 1;
        }
        return 1;
      });
      scroller.scrollTo('courses_section', {
        smooth: true,
        offset: 676 * totalElements,
      });
    }
  };

  const helperFalse = () => {
    setHelper(false);
  };

  const getValues = (evaluation) => {
    setIsFull(evaluation);
  };

  const handleChange = (event) => {
    if (!expanded && !checkLimit()) {
      setExpanded(expanded ? false : true);
    }
  };

  const changeStatus = (isActive) => {
    setExpanded(isActive ? true : false);
  };

  const handleSnackbar = () => {
    setFeedbackMessage({
      open: true,
      message: 'Tus cambios se han guardado con éxito',
      variant: 'success',
    });
  };

  const [edit, setEdit] = useState();

  const handleEditFlag = (flag) => {
    setEdit(flag);
  };

  const objectHasSomething = (array) => {
    const allValues = Object.values(array.slice(0, 1));
    const evaluation = allValues.some((elem) => {
      if (elem !== '') {
        return true;
      }
      return false;
    });
    return evaluation;
  };

  const objectIsEmpty = (array) => {
    const allValues = Object.values(array.slice(0, 1));
    const evaluation = allValues.every((elem) => {
      if (elem === '') {
        return true;
      }
      return false;
    });
    return evaluation;
  };

  let membershipLimit = 5
  let membershipLimitWord = 'cinco' 

  const [isLimit, setIsLimit] = useState(false);

  const handleIsLimit = (array) => {

    const arrayHasSomething = objectHasSomething(array);

    let completeArray;
    if (coursesLawyer && arrayHasSomething) {
      completeArray = [...array, ...coursesLawyer];
    } else if (coursesLawyer) {
      completeArray = [...coursesLawyer];
    } else {
      completeArray = [];
    }

    const completeArrayIsEmpty = objectIsEmpty(completeArray);

    if (
      (expanded && completeArray.length >= membershipLimit && !completeArrayIsEmpty) ||
      (array && array.length === membershipLimit)
    ) {
      setIsLimit(true);
    } else {
      setIsLimit(false);
    }
  };

  const checkLimit = () => {
    if (coursesLawyer && coursesLawyer.length === membershipLimit) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!expanded) {
      setIsFull(false);
    }
    coursesLawyer ? setnElem(coursesLawyer.length) : setnElem(0);
    setAlreadyRewarded(trophie);
  }, [coursesLawyer, expanded, trophie]);

  return (
    <div className="courses-lawyer">
      <ElementScroll name="courses_section">
        <CardProfile
          title='Cursos y diplomados'
          subTitle='Menciona cursos y diplomados que hayas concluido y que te aporten valor como profesional'
          awardIcon
          status={
            authClient && authClient.awardAditional.coursesLawyer
              ? authClient.awardAditional.coursesLawyer
              : false
          }
          style={{ padding: '24px 16px' }}
        >
          <ExpansionPanel expanded={expanded}>
            <ExpansionPanelSummary
              aria-controls="panel2a-content"
              style={{ backgroundColor: 'white' }}
            >
              {(coursesLawyer && coursesLawyer.length > membershipLimit) || edit ? (
                ''
              ) : !coursesLawyer || !coursesLawyer.length ? (
                <div
                  className={classes.expandButton}
                  onClick={expanded ? helperTrue : handleChange}
                  style={{
                    opacity:
                      (!expanded || isFull) && !checkLimit() && !isLimit
                        ? 'initial'
                        : 0.5,
                    cursor:
                      (!expanded || isFull) && !checkLimit() && !isLimit
                        ? 'pointer'
                        : 'not-allowed',
                  }}
                >
                  <p className="addAward_add">
                    <img className="plus" src="/img/profile/plus.svg" alt="" />
                    Añadir curso
                  </p>
                  <p className="addAward_limit">
                    Puedes añadir hasta {membershipLimitWord}
                  </p>
                </div>
              ) : (
                <div
                  className={classes.expandButton}
                  onClick={expanded ? helperTrue : handleChange}
                  style={{
                    opacity:
                      (!expanded || isFull) && !checkLimit() && !isLimit
                        ? 'initial'
                        : 0.5,
                    cursor:
                      (!expanded || isFull) && !checkLimit() && !isLimit
                        ? 'pointer'
                        : 'not-allowed',
                  }}
                >
                  <p className="addAward_add">
                    <img className="plus" src="/img/profile/plus.svg" alt="" />
                      Añadir curso
                  </p>
                  <p className="addAward_limit">Puedes añadir hasta {membershipLimitWord}</p>
                </div>
              )}

              {coursesLawyer ? (
                <div style={{paddingLeft: 14, width: '100%'}}>
                  <CourseAdded 
                    allCoursesItems={coursesLawyer}
                    handleSnack={handleSnackbar}
                    alreadyRewarded={alreadyRewarded}
                    handleRewarded={switchAlreadyRewarded}
                    handleTrophieModalOpen={handleTrophieModalOpen}
                    handleEditFlag={handleEditFlag}
                    nElem={nElem}
                    helper={helper}
                    helperTrue={helperTrue}
                    helperFalse={helperFalse}
                    getValues={getValues}
                  />
                </div>
              ) : null}
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <AddCourses
                handleSnack={handleSnackbar}
                evento={changeStatus}
                nElem={nElem}
                alreadyRewarded={alreadyRewarded}
                handleRewarded={switchAlreadyRewarded}
                handleTrophieModalOpen={handleTrophieModalOpen}
                helper={helper}
                helperTrue={helperTrue}
                helperFalse={helperFalse}
                getValues={getValues}
                handleIsLimit={handleIsLimit}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </CardProfile>
      </ElementScroll>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophieValidation}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Cursos y diplomados'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer="Al mencionar cursos y diplomados, aumentas tu información curricular y más personas querrán contactarte."
      />

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  openModalFree: (open, typeMembership, role ) => dispatch(openModalFree(open, typeMembership, role ))
})


const mapStateToProps = state => ({
  authClient: state.authClient,
  coursesLawyer: state.authClient.coursesLawyer,
  membershipType: state.authClient.membership.type,
  trophie: state.authClient.awardAditional.coursesLawyer,
});

export default connect(mapStateToProps, mapDispatchToProps)(Courses);

